import { authFetch } from "@/utils/api";

/** "Treinamento com especialista": offer, PIX, calendar. See apps/api/routes/training.js. */

export const trainingQueryKey = (accountId) => ["training", accountId];

async function readJson(res) {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body.error || "Não foi possível concluir agora.");
    err.code = body.code || null;
    err.status = res.status;
    throw err;
  }
  return body;
}

export async function fetchTraining(accountId) {
  return readJson(await authFetch(`/api/internal/training/${accountId}`));
}

export async function purchaseTraining(accountId, topics) {
  return readJson(
    await authFetch(`/api/internal/training/${accountId}/purchase`, { method: "POST", body: JSON.stringify({ topics }) }),
  );
}

export async function fetchTrainingSlots(accountId, date) {
  return readJson(await authFetch(`/api/internal/training/${accountId}/slots?date=${encodeURIComponent(date)}`));
}

export async function scheduleTraining(accountId, booking) {
  return readJson(
    await authFetch(`/api/internal/training/${accountId}/schedule`, { method: "POST", body: JSON.stringify(booking) }),
  );
}
